module.exports = __webpack_public_path__ + "img/GoDaddy-Black.37c2a035.png";